setTimeout(() => {
    const $custom = document.querySelector('.js-language-switch');
    const $selector = document.querySelector('.locale-selectors__container');

    if($custom && $selector) {
        $selector.prepend($custom.parentElement);
        $custom.style.display = 'none';
    }
}, 3000);
